import React from "react";

export default function FunctionalLayout(props) {
	return <>{props.children}</>;
}
